import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Modal from 'react-modal';

const List = () => {
	const [data, setData] = useState([]);
	const [selectedItem, setSelectedItem] = useState(null);
	const [filter, setFilter] = useState('');

	useEffect(() => {
		axios.get('data.json')
			.then(response => {
				const reversedData = response.data.projects.reverse();
				setData(reversedData);
			});
	}, []);

	const filteredData = data.filter(item =>
		item.title.toLowerCase().includes(filter.toLowerCase()) ||
		item.category?.toLowerCase().includes(filter.toLowerCase()) ||
		item.keywords?.toLowerCase().includes(filter.toLowerCase())
	);

	return (
		<div className="search-bar">
			<input
				type="text"
				value={filter}
				onChange={e => setFilter(e.target.value)}
				placeholder="Search items"
				className="search-bar"
			/>
			{filteredData.map(item => (
				<div key={item.id} style={{ display: 'flex', alignItems: 'flex-start', margin: '20px' }}>
					<img src={item.thumbnail} alt={item.title} width="350" style={{ marginRight: '20px', border: '2px solid #000' }} />
					<div style={{ textAlign: 'left' }}>
						<h4 style={{ marginBottom: '0px', fontWeight: 'normal', marginTop: '0px', fontSize: '0.9em' }}>{item.category}</h4>
						<h2 style={{ marginBottom: '2px', marginTop: '0px' }}>{item.title}</h2>
						<h3 style={{ fontWeight: 'lighter', marginTop: '0px' }}>{item.subtitle}</h3>
						<h4 style={{ marginTop: '0px' }}>{item.subsubtitle}</h4>
						<button className="popupclose" onClick={() => setSelectedItem(item)}>Open</button>
					</div>
				</div>
			))}

			{selectedItem && (
				<Modal isOpen={true} onRequestClose={() => setSelectedItem(null)} style={{
					content: {
						width: '50%',
						height: '60%',
						margin: 'auto',
						border: '3px solid #480760',
						background: '#000',
						overflow: 'auto',
						WebkitOverflowScrolling: 'touch',
						borderRadius: '4px',
						outline: 'none',
						padding: '20px'
					}
				}}>
					<h2>{selectedItem.title}</h2>
					<h3>{selectedItem.subtitle}</h3>

					<div style={{
						height: '175px', // Adjust this value as needed
						overflow: 'auto',
						padding: '10px',
						border: '1px solid #fff',
						marginTop: '10px',
						marginBottom: '10px'

					}}>
						<p>{selectedItem.description}</p>
					</div>

					<button className="popupclose" onClick={() => setSelectedItem(null)}>Close</button>

					{/* New buttons with the same class */}
					<button className="popupclose" onClick={() => window.open(selectedItem.htmlFile, '_blank')} disabled={!selectedItem.htmlFile} style={{ opacity: selectedItem.htmlFile ? 1 : 0.5 }}>Open Project</button>

					<button className="popupclose" onClick={() => {
						const agreement = window.confirm('Upon downloading this file, you are entering into an agreement to refrain from re-publishing it on the Scratch platform, regardless of whether it retains its original form or is presented as a remix. Click "OK" to agree and continue.');
						if (agreement) {
							const link = document.createElement('a');
							link.href = selectedItem.sb3File;
							link.download = selectedItem.sb3File;
							link.click();
						}
					}} disabled={!selectedItem.sb3File} style={{ opacity: selectedItem.sb3File ? 1 : 0.5 }}>Download</button>
				</Modal>
			)}
		</div>
	);
};

export default List;
